import React, { Fragment, useContext } from 'react';
import { MARKJENCO, MARKJENCOEMAIL } from '../../../../Constant';
import { H6, Image, P } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';
import CustomizerContext from '../../../../_helper/Customizer';

const HeaderProfile = () => {
    const { layoutURL } = useContext(CustomizerContext);
    return (
        <Fragment>
            <div className="media align-items-center">
                <div className="media-size-email">
                    <div className="media-body">
                    
					<H6 attrH6={{ className: 'f-w-600' }} >{"SCHEMES"}</H6>
                    
                   </div> 
                </div>
            </div>
        </Fragment>
    );
};

export default HeaderProfile;